module.exports = __webpack_public_path__ + "static/media/home_delivery.a3e9824c.jpg";